import React from 'react';
import styles from './Intuitive.module.css';

// Replace with your actual image paths
import image1 from '../../../assets/intuitive-asset1.png'; 
import image2 from '../../../assets/intuitive-asset2.png';
import image3 from '../../../assets/intuitive-asset3.png';

import asset4 from '../../../assets/orange_poly.png';
import asset5 from '../../../assets/green_poly.png';

const Intuitive = () => {
  return (
    <section className={styles.intuitive}>
      <div className={styles.imageContainer}>
        <img src={image1} alt="Intuitive Image 1" className={styles.largeImage} />
        <img src={image2} alt="Intuitive Image 2" className={styles.smallImage} />
        <img src={image3} alt="Intuitive Image 3" className={styles.smallImage} />

<img src={asset4} alt="Asset 4" className={styles.orangePoly} />
<img src={asset5} alt="Asset 5" className={styles.greenPoly} />
      </div>
      <h1 className={styles.intuitiveTitle}>INTUITIVE</h1>
    </section>
  );
};

export default Intuitive;
